exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-user-guide-glossary-tsx": () => import("./../../../src/pages/user-guide/glossary.tsx" /* webpackChunkName: "component---src-pages-user-guide-glossary-tsx" */),
  "component---src-templates-doc-tsx": () => import("./../../../src/templates/doc.tsx" /* webpackChunkName: "component---src-templates-doc-tsx" */)
}

